import { Body, Box, Card, H3, H4 } from '../widgets'
import { assetUrl } from '../../utilities.js'
import './WelcomeScreen.scss'

export const WelcomeScreen = ({
  title, description, titleSize, descriptionSize, className,
  firstCardClicked, firstCardTitle, firstCardDescription,
  secondCardClicked, secondCardTitle, secondCardDescription, cardProps
}) => {
  return <Box
    column
    fullWidth
    fullHeight
    alignItems="center"
    justifyContent="space-between"
    className={`welcome-screen ${className}`}
  >
    <Box column className="title">
      <H3 align="center">{title}</H3>
      <Body align="center">{description}</Body>
    </Box>
    <Box className="card-container">
      <Card
        className="card-1"
        background={`url(${assetUrl(`backgrounds/card-1.png`)})`}
        onClick={firstCardClicked}
        gap={8}
        column
        {...cardProps}
      >
        <H4 size={titleSize}>
          {firstCardTitle}
        </H4>
        <Body align="center" size={descriptionSize}>
          {firstCardDescription}
        </Body>
      </Card>
      <Card
        className="card-2"
        background={`url(${assetUrl(`backgrounds/card-2.png`)}), var(--yellow)`}
        onClick={secondCardClicked}
        gap={8}
        column
        {...cardProps}
      >
        <H4 size={titleSize}>
          {secondCardTitle}
        </H4>
        <Body align="center" size={descriptionSize}>
          {secondCardDescription}
        </Body>
      </Card>
    </Box>
    <Box />
  </Box>
}